.s{overflow:hidden;}